import Swal from 'sweetalert2/dist/sweetalert2.js'

export default function () {
    const prompts = document.querySelectorAll('[data-prompt-message]');

    prompts.forEach(promptItem => {
        promptItem.addEventListener('click', function (event) {
            event.preventDefault();
            const message = promptItem.dataset.promptMessage;

            var defaultAction = promptItem.getAttribute("href");
            var content = document.createElement("div");
            content.innerHTML = message;

            Swal.fire({
                title: 'Potwierdzenie',
                html: content,
                icon: 'warning',
                confirmButtonText: 'Tak',
                cancelButtonText: 'Nie',
                showCancelButton: true,
                reverseButtons: true
            }).then(function (result) {
                              
                if (result.isConfirmed) {
                    window.location = defaultAction;
                }
            });
        });
    });
}